// extracted by mini-css-extract-plugin
export default {"model":"Model_model__8-lv0","infoLabel":"Model_infoLabel__FlI9v","required":"Model_required__6NP6M"};